// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// ## Product Get
/**
 *
 * @param {{params: object, query: { search: string, parasutAccountId: string, productCategoryId: string, lowToHighSort: boolean, mostSaleProductSort: boolean, newProductSort: boolean, prioritySort: boolean, onlyProduct: boolean, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.Product.GetAll({
      query: {
        ...option.query,
        parasutAccountId: option.query?.companyId || "",
      },
      params: option.params,
    })
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Product Create
/**
 *
 * @param {{"name": string,"description": string,"productCategoryId": string,"price": number,"costPrice"?: number,"vatRate": number, stockCount: number, image: File, productInfos: Array, applyDiscount: boolean, isPriority: boolean}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Product.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Product Update
/**
 *
 * @param {{"name": string,"description": string,"productCategoryId": string,"price": number,"costPrice"?: number,"vatRate": number, stockCount: number, image: File, productInfos: Array, applyDiscount: boolean, isPriority: boolean, isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Product.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Update,
  Create,
};
